import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=5dcf3c7c&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"
import style0 from "./Featured.vue?vue&type=style&index=0&id=5dcf3c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf3c7c",
  null
  
)

export default component.exports